import { render } from "./ButtonGroup.vue?vue&type=template&id=51658a1d"
import script from "./ButtonGroup.vue?vue&type=script&lang=ts"
export * from "./ButtonGroup.vue?vue&type=script&lang=ts"

import "./ButtonGroup.vue?vue&type=style&index=0&id=51658a1d&lang=css"
script.render = render

export default script